import { ITransaction } from '../interface/transaction';

export const STATUS_CODE = {
  UNAUTHORIZED: 401,
  FORBIDDEN_EXCEPTION: 403,
  SOME_THING_WRONG: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  TOO_MANY_REQUESTS: 429,
  ENTITY_NOT_FOUND: 404,
  CONFLICT: 409,
};
export const SOME_THING_WRONG_CODES = [500, 503, 502, 504, 429];
export const ROUTES = {
  DEFAULT: '/',
  DASHBOARD: '/dashboard',
  ANALYTICS: '/analytics',
  ACCESS_FORBIDDEN: '/access-forbidden',
  NO_INTERNET: '/no-internet',
  OUTLOOK_APP: '/outlook-app',
  ERROR: '/error',
  TRANSACTION_VIEW: '/transaction-view',
  NOTES_VIEW: '/notes-view',
  ADD_EDIT_TRANSACTION: '/transaction',
  ADD_TRANSACTION_FROM_MAIL: '/transaction-mail',
  MATTER_SELECTION: '/matter-selection',
  TASK_MATTER_SELECTION: '/task/matter-selection',
  TASK_PRIORITY_SELECTION: '/task/priority',
  TRANSACTION_TYPE_SELECTION: '/transaction-type-selection',
  ADD_SKILLS: '/add-skills',
  ADD_MATTER_PHASE: '/add-matter-phase',
  NEED_SUGGESTIONS: '/need-suggestions',
  TASKS_LIST: '/tasks-list',
  TASKS_DETAIL: '/tasks-detail',
  CRITICAL_TASKS_DETAIL: '/critical-tasks-detail',
  WORK_TIME_DETAIL: '/work-time-detail',
  ADD_EDIT_TASK: '/tasks',
  ADD_EDIT_CRITICAL_TASK: '/critical-tasks',
  TASK_STATUSES: '/task-statuses',
  PERSON_LISTING: '/critical/person-listing',
  TIMER_LIST: '/timer-list',
  TIMER_DETAIL: '/timer-detail',
  TIMER_ADD_EDIT: '/timer',
  ADD_EDIT_NOTES: '/notes',
  CONFLICT_SEARCH: '/conflict-search',
  CONFLICT_CHECKS: '/conflict-checks',
  SELECT_USER: '/select-user',
  MATTER_REQUEST: '/matter-request',
  MANAGE_MATTER_REQUEST: '/manage-matter-request',
  TRANSACTION_LISTING: '/transactions',
  TRANSACTION_TIMESHEET_LIST: '/transaction-timesheet-list',
  PROFILE: '/profile',
  PROFILE_ABOUT: '/profile-about',
  LANGUAGE_AND_REGION: '/language-and-region',
  PREFERENCES: '/preferences',
  FEATURE_SELECTION: '/feature-selection',
  CUSTOMER_LISTING: '/customers',
  MATTER_DETAIL: '/matter-detail',
  MATTER_REQUEST_DETAIL: '/matter-request-detail',
  MATTERS_LISTING: '/matters-listing',
  INVOICING: '/invoicing',
  EXPENSE_DETAIL: '/expense-detail',
  BILLABLE_MATTER_DETAIL: '/billable-matter-detail',
  PRELIMINARY_INVOICE_DETAIL: '/preliminary-invoice-detail',
  WORK_TIME: '/work-time-list',
  ADD_EDIT_WORK_TIME: '/work-time',
  WORK_TIME_TYPE: '/work-time-type',
  MATTER_REQUEST_TYPE_LISTING: '/matter-request-type-listing',
  LANGUAGE_LISTING: '/language-listing',
  CURRENCY_LISTING: '/currency-listing',
  COUNTRY_LISTING: '/country-listing',
  BUSINESS_AREA_LISTING: '/business-area-listing',
  MATTER_REQUEST_USER_LISTING: '/matter-request-user-listing',
  ACTIVITY_SELECTION: '/activity-selection',
  TASKPANE_AUTH_REDIRECTION: '/auth-callback',
};
export const LOCAL_STORAGE_NAMES = {
  appAnalyticsPermission: 'appUserAnalyticsPermission',
  currentOrganisation: 'currentOrganisation',
  user: 'user',
  language: 'language',
  theme: 'theme',
  timer: 'timer',
  featureSelections: 'featureSelections',
  startModule: 'startModule',
  defaultViewPreference: 'defaultViewPreference',
  displaySize: 'displaySize',
  themeColor: 'themeColor',
  isOnboarding: 'isOnboarding',
  isSelectingOrganisation: 'isSelectingOrganisation',
  dragabbleButtonsPosition: 'draggable-button-positions',
  csrfToken: 'csrfToken',
  officeAddinTokenExpiry: 'officeAddinTokenExpiry',
  csiAppVersion: 'csiAppVersion',
  dashboardChartVisible: 'dashboardChartVisible',
};
export const PRIVACY_POLICY_URLS = {
  en: 'https://www.csihelsinki.fi/en/privacy-policy/',
  sv: 'https://www.csihelsinki.fi/sv/privacy-policy/',
  fi: 'https://www.csihelsinki.fi/fi/privacy-policy/',
};

export enum UserType {
  NORMAL = 'normal',
  ADMIN = 'admin',
  RESTRICTED = 'restricted',
}
export enum ActivePopover {
  ORGANISATION = 'Organization',
  APPEARANCE = 'Appearance',
  LANGUAGE = 'Language',
  TRANSACTION_PARAMETERS = 'Transaction parameters',
  PREFERENCES = 'Preferences',
  ABOUT = 'About',
}
export enum InvoiceableDurationStep {
  SIX_MINUTES = 'sixMinutes',
  TWELVE_MINUTES = 'twelveMinutes',
  FIFTEEN_MINUTES = 'fifteenMinutes',
  THIRTY_MINUTES = 'thirtyMinutes',
  NONE = 'none',
}
export enum InvoiceableDurationStepValue {
  SIX_MINUTES = '6',
  TWELVE_MINUTES = '12',
  FIFTEEN_MINUTES = '15',
  THIRTY_MINUTES = '30',
  NONE = 'none',
}
export const UI_LANGUAGE_TAGS: Record<string, string> = {
  en: 'en-US',
  fi: 'fi-FI',
  sv: 'sv-SE',
};
export const normalizeAppLanguage = (locale: string): string => {
  const languageCode = locale.split('-')[0].toLowerCase();
  return languageCode in UI_LANGUAGE_TAGS ? languageCode : 'en';
};
export enum ThemeMode {
  dark = 'Dark',
  light = 'Light',
  system = 'System',
}
export const supportEmail = 'help@csihelsinki.fi';
export const supportSubject = 'CSI Office-Addin support request';
export const DATE_FORMAT_TRANSACTION = 'MMM DD, YYYY';

export const TransactionStatusValue = {
  open: 'Open',
  'non-billable': 'Non Billable',
  reviewed: 'Reviewed',
  invoiced: 'Invoiced',
  'preliminary-invoice': 'Preliminary Invoice',
  'uplift-downlift': 'Uplift Downlift',
  approved: 'Approved',
  incomplete: 'Incomplete',
};
export enum SystemConstants {
  UNIT_HOUR = 'FD8FB7DB-8881-4EC1-AEA7-7BEE0BEF59E3',
  CRITICAL_TASK_ID = '201E66A7-C7D3-465E-8922-A02EEF6EEC6B',
  TASK_ID = '080E565F-59FF-4DFD-97CF-CB0372A8F550',
  TAXABILITY_TAX_INCLUDED = 'D11C5C1D-0E46-4E87-A7A1-BA8AA61FB40F',
  DEFAULT_RISK_ASSESSMENT = '0FABA57B-AB4B-44B2-B523-14E0B65741CD',
  PAYER_ROLE = '63307673-31CB-4BED-9A81-793A05DB022A',
  PRINCIPAL_ROLE = '05394BA7-3201-4D8F-8520-E8FC7CB66681',
  TASK_STATUS_NOT_STARTED = '118A7D24-A558-4CC8-8E75-7B5D9723696D',
  TASK_STATUS_COMPLETED = 'E4B9F409-1917-48DB-B39E-933DA94A8593',
}
export enum TransactionFilters {
  open = 'open',
  all = 'all',
}
export const MY_OWN_FILTER = 'myOwn';
export const TransactionKeys: (keyof ITransaction)[] = [
  'currentSubject',
  'matterId',
  'transactionDate',
  'billableQuantity',
  'workedHours',
  'transactionTypeId',
  'unitPrice',
];
export const TransactionPostingPeriodStatus = {
  OPEN: 'open',
  LOCKED: 'locked',
};
export const Auth0ErrorCodes = {
  login_required: 'login_required',
  invalid_grant: 'invalid_grant',
  mfa_required: 'mfa_required',
};
export const expiredAuthErrors = [
  Auth0ErrorCodes.invalid_grant,
  Auth0ErrorCodes.login_required,
  Auth0ErrorCodes.mfa_required,
];
export const invalidGrantErrorMessages = ['token refresh failed', 'token validation failed'];
export const NETWORK_RETRY = {
  MAX_ATTEMPTS: 3,
  BASE_DELAY_MS: 1000,
  // a dropped connection can still have reached the server, so only methods that are safe to repeat are retried
  RETRYABLE_METHODS: new Set(['GET', 'HEAD', 'OPTIONS']),
};
export const MAX_LIMIT_VALUE_TRANSACTION = 9999.99;
export const MAX_FILE_SIZE = 1 * 1024 * 1024;
export const RELEASE_NOTES_API_INTERVAL = 1000 * 60 * 60;
export const RELEASE_NOTES_PRODUCT_IDENTIFIER = 'office-addin';
export enum DashboardTabs {
  recentTransactions = 'recentTransactions',
  weeklyBudget = 'weeklyBudget',
}

export const MODAL_CANCEL_BUTTON_MAX_WIDTH = 'calc(100% * 114 / 340)';
export const MODAL_CONFIRM_BUTTON_MAX_WIDTH = 'calc(100% * 221 / 340)';
